import React, { useState } from "react";
import "./Projects.css";
import close from "../../Assets/Icons/cancel.png";
import gitHub from "../../Assets/Icons/github-logo.png";
import demo from "../../Assets/Icons/link.png";
import Modal from "../UI/Modal";
import classes from "./QuickView.module.css";

function ProjectItem(props) {
  const [showQuickView, setShowQuickView] = useState(false);

  function showQuickViewHandler() {
    // show quick view component, model
    setShowQuickView((prev) => !prev);
  }
  return (
    <React.Fragment>
      <div className="project" onClick={showQuickViewHandler}>
        <div className="image">
          <img src={props.image} alt="" />
        </div>
        <h4>{props.title}</h4>
        <div className="language">
          {props.lang?.map((item) => (
            <span>{item}</span>
          ))}
        </div>
      </div>
      {showQuickView && (
        <Modal onClose={props.onClose}>
          <div className={classes["quick-view"]}>
            <div>
              <div
                onClick={showQuickViewHandler}
                className={classes["close-icon"]}
              >
                <img src={close} alt="" />
              </div>
            </div>
            <div className={classes.content}>
              <div className={classes.image}>
                <img src={props.image} alt="" />
              </div>

              <div className={classes.text}>
                <h4>{props.title}</h4>
                <h5>Description: </h5>
                <p>{props.description}</p>
                <h5>Features: </h5>
                <div className={classes.features}>
                  <ul>
                    {props.features.map((item) => (
                      <li>{item}</li>
                    ))}
                  </ul>
                </div>
                <div className={classes.language}>
                  {props.lang?.map((item) => (
                    <span>{item}</span>
                  ))}
                </div>
                <div className={classes.buttons}>
                  <button>
                    <a
                      href={props.links.github}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <span>GitHub Code</span>
                      <img src={gitHub} alt="" />
                    </a>
                  </button>
                  <button>
                    <a
                      href={props.links.liveDemo}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <span>Live Demo</span>
                      <img src={demo} alt="" />
                    </a>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </React.Fragment>
  );
}

export default ProjectItem;
